import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../resources/ResourcesStore";
import { injectFromAppLegal } from "../inject";
import { GeneralPrivacyPolicyComponent } from "./general/GeneralPrivacyPolicyComponent";
import { PrivacyPolicyDocumentComponent } from "./PrivacyPolicyDocumentComponent";
import { LegalPartialContainerComponent } from "../LegalPartialContainerComponent";
import { LegalPartialSubcontainerComponent } from "../LegalPartialSubcontainerComponent";

interface IPrivacyPolicyComponentProps {
    resourcesStore?: IResourcesStore;
}

@injectFromAppLegal<IPrivacyPolicyComponentProps>(stores => ({
    resourcesStore: stores.resourcesStore,
}))
@observer
export class PrivacyPolicyComponent extends React.Component<IPrivacyPolicyComponentProps> {
    constructor(props: IPrivacyPolicyComponentProps) {
        super(props);
    }

    render() {
        const { resourcesStore } = this.props;
        const { resources } = resourcesStore!;

        return (
            <LegalPartialContainerComponent title={resources.PrivacyPolicy}>
                <LegalPartialSubcontainerComponent title={`${resources.General}`}>
                    <GeneralPrivacyPolicyComponent />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.Argentina}`}>
                    <PrivacyPolicyDocumentComponent country={"Argentina"} />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.Bolivia}`}>
                    <PrivacyPolicyDocumentComponent country={"Bolivia"} />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.Chile}`}>
                    <PrivacyPolicyDocumentComponent country={"Chile"} />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.Colombia}`}>
                    <PrivacyPolicyDocumentComponent country={"Colombia"} />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.ElSalvador}`}>
                    <PrivacyPolicyDocumentComponent country={"ElSalvador"} />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.Guatemala}`}>
                    <PrivacyPolicyDocumentComponent country={"Guatemala"} />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.Mexico}`}>
                    <PrivacyPolicyDocumentComponent country={"Mexico"} />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.Panama}`}>
                    <PrivacyPolicyDocumentComponent country={"Panama"} />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.Brazil}`}>
                    <PrivacyPolicyDocumentComponent country={"Brazil"} />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.CostaRica}`}>
                    <PrivacyPolicyDocumentComponent country={"CostaRica"} />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.Spain}`}>
                    <PrivacyPolicyDocumentComponent country={"Spain"} />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.Nicaragua}`}>
                    <PrivacyPolicyDocumentComponent country={"Nicaragua"} />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.Peru}`}>
                    <PrivacyPolicyDocumentComponent country={"Peru"} />
                </LegalPartialSubcontainerComponent>
                <LegalPartialSubcontainerComponent title={`${resources.Switzerland}`}>
                    <PrivacyPolicyDocumentComponent country={"Switzerland"} />
                </LegalPartialSubcontainerComponent>
            </LegalPartialContainerComponent>
        );
    }
}
